import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { Button } from '@jutro/legacy/components';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import messages from './OpeEstSearchComponent.messages';

import styles from './OpeEstSearchComponent.module.scss';
import metadata from './OpeEstSearchComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';



function OpeEstSearchComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated,index, viewModelService, setSubmission } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('OpeEstSearchComponent');
    const modelVM = _.get(submissionVM, pathUpdated);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();

    const { LoadSaveService } = useDependencies('LoadSaveService');

    const [operationCodeSearchVisible, setOperationCodeSearchVisible] = useState(false);
    const [operations, updateOperations] = useState('');
    const [estheticClass, updateEstheticClass] = useState('');
    const opeFiePath = `${pathUpdated}.opeFie.value`;
    const estheticClassPath = `${pathUpdated}.estClaFie.value`;


    const onCell = (item, index, { id: property }) => item[property];

    const renderSelectButton = (item, index, { id: property }) => (
            // eslint-disable-next-line react/jsx-no-literals
            <Button type='text'  onClick={(e) => onActionClick(item)}>
                {translator(messages.select)}
            </Button>
        );

    const loadData = ({ pageSize, page }) => {
        const paginationParams = {
            fromPage: page,
            pageSize: pageSize
        };

        return searchOperationCode(paginationParams);
    };

    const searchOperationCode = async(paginationParams) => {
       
        if(!paginationParams) {
            paginationParams = {
                fromPage: 0,
                pageSize: 10
            };
        }

        const opeEstClassCodeDTO = {
            estheticClass: estheticClass,
            operations: operations
        };

        const reqParam = {
            opeEstClassCodeDTO: opeEstClassCodeDTO,
            pageNumber: paginationParams.fromPage,
            pageSize: paginationParams.pageSize
        }
        
        const response = await LoadSaveService.getSpaWellOpeEstClassCodes_Ext(reqParam, authHeader);
        
        setOperationCodeSearchVisible(true);

        if(response != null){
            
            return {
                rows: response.opeEstCodes,
                numberOfRows: response.maxNumberOfResults
            };

        } else {
            return {
                rows: [],
                numberOfRows: 0
            };
        }
    };

    const clearSearchTexts = () => {
        updateOperations('');
        updateEstheticClass('');
    }

    const cancelSearch = () => {
        setOperationCodeSearchVisible(false);
    }

    const openSearchPanel = () => {
        setOperationCodeSearchVisible(true);
    } 

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onActionClick = (object, index) => {
        _.set(submissionVM, opeFiePath, object.operations); 
        _.set(submissionVM, estheticClassPath, object.estheticClass); 
        setOperationCodeSearchVisible(false);
        setSubmission(submissionVM)
    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        opeEstSearchBtn: {
            onClick: () => { searchOperationCode(); },
            visible: false
        },
        OpeEstAdapters: {
            visible: operationCodeSearchVisible,
            key: estheticClass,
            onFetchData: loadData
        },
        OpeEstSearchContainer: {
            visible: operationCodeSearchVisible
        },
        OpeEstAllContainer: {
            visible: operationCodeSearchVisible
        },
        OpeEstResetBtn: {
            onClick: () => { clearSearchTexts(); }
        },
        OpeEstCancelBtn: {
            onClick: () => {cancelSearch(); }
        }, 
        OpeEstSearchIconBtn: {
            onClick: () => {openSearchPanel(); }
        },
        estheticClassSearchInput : {
            value: estheticClass,
            onValueChange: updateEstheticClass
        },
        opeEstCatSearchInput : {
            value: operations,
            onValueChange: updateOperations
        },
        searchResultHeader: {
            visible: operationCodeSearchVisible
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            onActionClick,
            onCell,
            renderSelectButton
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback((id, path) =>
         readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OpeEstSearchComponent.propTypes = wizardProps;
export default withRouter(OpeEstSearchComponent);
